import React from 'react'
import { withData } from '../withData'
import { withState, compose } from 'recompose'
import _ from 'lodash'
import { PatientCard } from '../Card/PatientCard'
import { graphql } from '../graphql'
import './CaregiverList.scss'
import {
  Input,
  Modal,
  Icon,
  Card
} from 'antd'
import { Helmet } from 'react-helmet'

const confirm = Modal.confirm

const q = `
  query {
    caregivers() {
      displayName,
      displayImage,
      user {
        id,
        firstname,
        lastname
      }
    }
  }
`

const enhance = compose(
  withData(q),
  withState('addModalOpen', 'setAddModalOpen', false),
  withState('addingEmail', 'setAddingEmail', '')
)

const removePrompt = (e, caregiver, data, setData) => {
  e.stopPropagation()
  e.preventDefault()
  console.log('removing', caregiver)
  const { user } = caregiver
  const caregiverId = user.id
  confirm({
    title: `จะลบผู้ดูแล ${user.firstname} ${user.lastname} หรือไม่?`,
    content: 'หากลบแล้วจะไม่มีการแจ้งเตือนไปยังผู้ดูแลนี้อีก รวมถึงผู้ดูแลจะไม่สามารถเข้าถึงข้อมูลของคุณได้',
    okText: 'ลบผู้ดูแล',
    cancelText: 'ยกเลิก',
    onOk: () => {
      const deleteMutation = `
        mutation {
          removeCaregiver(
            caregiverId: "${caregiverId}"
          ) {
            success
          }
        }
      `
      graphql(deleteMutation).then((response) => {
        console.log(response)
        if (_.get(response, 'data.removeCaregiver.success')) {
          setData({
            data: {
              caregivers: _.reject(data.data.caregivers, (caregiverObject) => {
                console.log('caregiver:', caregiverObject)
                return caregiverObject.user.id === caregiverId
              })
            }
          })
        }
      })
    },
    onCancel: () => {
      console.log('Cancelled')
    }
  })
}

const handleSubmit = (email, onSuccess, setData, data) => {
  console.log('email:', email)
  const addCaregiverMutation = `
    mutation {
      addCaregiver(
        email: "${email}",
        role: "CARE_GIVER"
      ) {
        displayName,
        displayImage,
        user {
          id,
          firstname,
          lastname
        }
      }
    }
  `
  graphql(addCaregiverMutation).then((response) => {
    console.log('response:', response)
    if (response) {
      onSuccess()
      const newCaregiver = response.data.addCaregiver
      setData({
        data: {
          caregivers: _.concat(data.data.caregivers, newCaregiver)
        }
      })
    }
  })
}

const CaregiverList = ({ data, setAddModalOpen, addModalOpen, setAddingEmail, addingEmail, setData }) => {
  console.log('data:', data)
  const caregivers = _.get(data, 'data.caregivers') || []
  return (
    <div className="caregivers">
      <Helmet>
        <title>รายชื่อผู้ดูแลของคุณ</title>
      </Helmet>
      <h2>
        <center>รายชื่อผู้ดูแลของคุณ</center>
      </h2>
      {_.map(caregivers, (caregiver, index) => {
        console.log('caregiver:', caregiver)
        return (
          <div className="caregiver" key={index}>
            <PatientCard userInfo={caregiver} />
            <Icon className="delete-button-icon" type="close-circle-o" onClick={(e) => removePrompt(e, caregiver, data, setData)} />
          </div>
        )
      })}
      <div onClick={() => setAddModalOpen(_.constant(true))}>
        <Card className="caregiver">
          <div className="add-caregiver">
            <Icon type="plus" /> เพิ่มผู้ดูแล
          </div>
        </Card>
      </div>
      <Modal
        title="เพิ่มผู้ดูแล" visible={addModalOpen}
        okText="เพิ่ม" cancelText="ยกเลิก"
        onOk={() => {
          const onSuccess = () => {
            setAddModalOpen(_.constant(false))
          }
          handleSubmit(addingEmail, onSuccess, setData, data)
        }} onCancel={() => setAddModalOpen(_.constant(false))}
      >
        <p>อีเมล์ผู้ดูแล</p>
        <Input
          placeholder="caregiver@example.com"
          value={addingEmail}
          onChange={(e) => setAddingEmail(e.target.value)}
        />
      </Modal>
    </div>
  )
}

export default enhance(CaregiverList)



// WEBPACK FOOTER //
// ./src/CaregiverList/CaregiverList.js